import type { CcPreviewStep, CcServiceOption } from './types';

export const GROWTH_CAMPAIGN_CREATE_META = {
  eyebrow: 'Google Ads · Create Campaign',
  titleLead: 'Your top growth',
  titleAccent: 'opportunities',
  description:
    'ELVA identified the campaigns that can bring new patients this month by combining your local market data with your clinic strengths. Review and launch the ones you like.',
} as const;

export const GROWTH_CAMPAIGN_PREVIEW_META = {
  eyebrow: 'Google Ads · Review & Launch',
  titleLead: 'Review your',
  titleAccent: 'campaign',
  description:
    'ELVA built this campaign based on your request. Review everything below — ads, keywords, landing page, and tracking — then approve to go live.',
} as const;

export const CC_SERVICE_OPTIONS: CcServiceOption[] = [
  { value: '', label: 'Select a service…' },
  { value: 'emergency', label: 'Emergency Dental Care' },
  { value: 'implants', label: 'Dental Implants' },
  { value: 'invisalign', label: 'Invisalign / Clear Aligners' },
  { value: 'whitening', label: 'Teeth Whitening' },
  { value: 'veneers', label: 'Cosmetic Dentistry (Veneers)' },
  { value: 'family', label: 'Pediatric / Family Dentistry' },
  { value: 'sedation', label: 'Sedation Dentistry' },
  { value: 'checkups', label: 'General Checkups & Cleanings' },
  { value: 'other', label: 'Other' },
];

export const CC_PREVIEW_STEPS: CcPreviewStep[] = [
  { label: 'Campaign Details' },
  { label: 'ELVA Generates' },
  { label: 'Review & Launch' },
];
